import { render, staticRenderFns } from "./MeatPoultryStep.vue?vue&type=template&id=28671f05&scoped=true&"
import script from "./MeatPoultryStep.vue?vue&type=script&lang=js&"
export * from "./MeatPoultryStep.vue?vue&type=script&lang=js&"
import style0 from "./MeatPoultryStep.vue?vue&type=style&index=0&id=28671f05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28671f05",
  null
  
)

export default component.exports